var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "input-w240",
              attrs: {
                inline: true,
                "label-width": "75px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.OrderNo2") + ":" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px", "margin-left": "40px" },
                    attrs: { no: "orderNo", disabled: true },
                    model: {
                      value: _vm.order.orderNo,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "orderNo", $$v)
                      },
                      expression: "order.orderNo"
                    }
                  })
                ],
                1
              ),
              _vm.orderType === 3
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "40px" },
                      attrs: { label: _vm.$t("RailwayExport.BoxOwner3") + ":" }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px", "margin-left": "40px" },
                        attrs: {
                          no: "sellerId",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": { active: true },
                          filterable: "",
                          "default-value": _vm.order.sellerId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.order.sellerId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.orderType === 2
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "40px" },
                      attrs: { label: _vm.$t("RailwayExport.Buyer2") + ":" }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px", "margin-left": "40px" },
                        attrs: {
                          no: "buyerId",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": { active: true },
                          filterable: "",
                          "default-value": _vm.order.buyerId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.order.buyerId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.orderType !== 3 && _vm.orderType !== 2
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "40px" },
                      attrs: { label: _vm.$t("RailwayExport.BoxOwner2") + ":" }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px", "margin-left": "40px" },
                        attrs: {
                          no: "sellerId",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": { active: true },
                          filterable: "",
                          "default-value": _vm.order.sellerId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.order.sellerId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.orderType === 3,
              expression: "orderType===3"
            }
          ],
          staticClass: "app-main-row"
        },
        [
          _c(
            "el-form",
            {
              staticClass: "input-w240",
              attrs: {
                inline: true,
                "label-width": "75px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.RentDate") + ":" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px", "margin-left": "40px" },
                    attrs: {
                      no: "rentDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.order.rentDate,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "rentDate", $$v)
                      },
                      expression: "order.rentDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-left": "40px" },
                  attrs: { label: _vm.$t("RailwayExport.ReturnDate") + ":" }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px", "margin-left": "40px" },
                    attrs: {
                      no: "returnDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.order.returnDate,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "returnDate", $$v)
                      },
                      expression: "order.returnDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "input-w240",
              attrs: {
                inline: true,
                "label-width": "75px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.orderType !== 3 && _vm.orderType !== 2,
                      expression: "orderType!==3&&orderType!==2"
                    }
                  ],
                  attrs: { label: _vm.$t("RailwayExport.BuyTime") + ":" }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px", "margin-left": "40px" },
                    attrs: {
                      no: "buyerDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.order.buyerDate,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "buyerDate", $$v)
                      },
                      expression: "order.buyerDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.orderType === 2,
                      expression: "orderType===2"
                    }
                  ],
                  attrs: { label: _vm.$t("RailwayExport.SellerDate") + ":" }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px", "margin-left": "40px" },
                    attrs: {
                      no: "sellerDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.order.sellerDate,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "sellerDate", $$v)
                      },
                      expression: "order.sellerDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  style: { marginLeft: _vm.orderType !== 3 ? "40px" : "" },
                  attrs: { label: _vm.$t("RailwayExport.SettlingTime") + ":" }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px", "margin-left": "40px" },
                    attrs: {
                      no: "settlementDate",
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.order.settlementDate,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "settlementDate", $$v)
                      },
                      expression: "order.settlementDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "app-main-row" }, [
        _c("div", { staticStyle: { width: "680px", display: "flex" } }, [
          _c(
            "div",
            {
              staticStyle: {
                width: "386px",
                "padding-left": "11px",
                "margin-right": "70px"
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("RailwayExport.QuantitySum")) +
                  "：" +
                  _vm._s(_vm.containerLabel) +
                  " " +
                  _vm._s(_vm.$t("RailwayExport.AmountSum")) +
                  "：" +
                  _vm._s(_vm.amountLabel) +
                  " " +
                  _vm._s(_vm.amountLabel ? _vm.container.currencyCode : "") +
                  " "
              )
            ]
          ),
          _c(
            "div",
            [
              _vm._v(
                " " + _vm._s(_vm.$t("RailwayExport.WhetherSettlement")) + "： "
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "160px" },
                  attrs: { no: "ifSettlement" },
                  model: {
                    value: _vm.order.ifSettlement,
                    callback: function($$v) {
                      _vm.$set(_vm.order, "ifSettlement", $$v)
                    },
                    expression: "order.ifSettlement"
                  }
                },
                _vm._l(_vm.JUDGE_STATUS, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.chineseName, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("div", {
        staticClass: "app-main-row",
        staticStyle: { margin: "5px 0", "border-bottom": "1px solid #adaeb1" }
      }),
      _c(
        "div",
        { staticClass: "app-main-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "input-w160",
              attrs: {
                inline: true,
                "label-width": "60px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.EQSize") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "eqsize",
                      "select-type": _vm.TYPE_NAMES.local_cache_EQSize3,
                      fields: ["code"],
                      filterable: "",
                      "default-value": _vm.container.eqsize,
                      "tag-name": "code"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.container.eqsize = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.EQType") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "eqtype",
                      "select-type": _vm.TYPE_NAMES.basic_data_EQType,
                      fields: ["code"],
                      filterable: "",
                      "default-value": _vm.container.eqtype,
                      "tag-name": "code"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.container.eqtype = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.Quantity2") } },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "cQ",
                      precision: 0,
                      controls: false,
                      min: 0,
                      max: 999
                    },
                    model: {
                      value: _vm.cQ,
                      callback: function($$v) {
                        _vm.cQ = $$v
                      },
                      expression: "cQ"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-row",
          staticStyle: { "margin-bottom": "6px" }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "input-w160",
              attrs: {
                inline: true,
                "label-width": "60px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.UnitRate") } },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "unitPrice",
                      precision: 2,
                      controls: false,
                      min: 0
                    },
                    model: {
                      value: _vm.container.unitPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.container, "unitPrice", $$v)
                      },
                      expression: "container.unitPrice"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("RailwayExport.CurrencyCode") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled:
                        _vm.rowData.length > 0 ||
                        Boolean(_vm.railway && _vm.railway.currencyCode),
                      no: "currencyCode",
                      "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                      fields: ["code"],
                      filterable: "",
                      "default-value": _vm.container.currencyCode,
                      "tag-name": "code"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.container.currencyCode = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                [
                  _c("el-input", {
                    attrs: { no: "remarks", maxlength: "50" },
                    model: {
                      value: _vm.container.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.container, "remarks", $$v)
                      },
                      expression: "container.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Add", type: "primary" },
              on: { click: _vm.addHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-row" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "300px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.successHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [
          _c(
            "el-button",
            {
              ref: "deleteBtnTemplate",
              attrs: { type: "primary", no: "1", onclick: "void(0)" }
            },
            [_vm._v(_vm._s(_vm.$t("RailwayExport.Delete")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }